<template>
  <div class="tli" @click="$emit('toggle', ticket.ticket_id)">
    <div class="tli-row">
      <div class="tli-main">
        <span class="tli-id">{{ ticket.ticket_id }}</span>
        <span class="tli-subject">{{ ticket.asunto }}</span>
      </div>
      <span class="tli-badge" :class="badgeClass">{{ stateLabel }}</span>
    </div>
    <div class="tli-sub">
      {{ ticket.categoria }} · {{ priorityLabel }}{{ priorityLabel ? ' · ' : '' }}{{ formatDate(ticket.fecha_apertura) }}
    </div>

    <div v-if="isOpen" class="tli-detail">
      <p v-if="ticket.descripcion"><strong>Descripción:</strong> {{ ticket.descripcion }}</p>
      <p v-if="ticket.committed_delivery_date">
        <strong>Fecha de entrega comprometida:</strong> {{ formatDay(ticket.committed_delivery_date) }}
      </p>
      <p v-if="ticket.fecha_limite_resolucion && !isFinished">
        <strong>Fecha límite:</strong> {{ formatDate(ticket.fecha_limite_resolucion) }}
      </p>
      <p v-if="isFinished && ticket.fecha_cierre">
        <strong>Cerrado el:</strong> {{ formatDate(ticket.fecha_cierre) }}
      </p>
      <p v-if="ticket.motivo_raiz"><strong>Motivo raíz:</strong> {{ ticket.motivo_raiz }}</p>
      <p v-if="ticket.last_rejection_reason && !isFinished">
        <strong>Tu último comentario:</strong> {{ ticket.last_rejection_reason }}
      </p>
      <p v-if="ticket.evidencia_url">
        <strong>Evidencia:</strong>
        <a :href="ticket.evidencia_url" target="_blank" rel="noopener" @click.stop>ver enlace</a>
      </p>
      <ticket-confirmation-actions
        v-if="isAwaiting"
        :ticket="ticket"
        :start-rejecting="startRejecting"
        @done="$emit('changed')"
      />
    </div>
  </div>
</template>

<script>
import TicketConfirmationActions from './TicketConfirmationActions.vue';
import {
  PRIORITY_LABELS,
  isAwaitingConfirmation,
  isTicketFinished,
  ticketStateLabel,
} from '@/utils/ticketStates';

export default {
  name: 'TicketListItem',
  components: { TicketConfirmationActions },
  props: {
    ticket: { type: Object, required: true },
    isOpen: { type: Boolean, default: false },
    startRejecting: { type: Boolean, default: false },
  },
  computed: {
    isFinished() { return isTicketFinished(this.ticket.estado); },
    isAwaiting() { return isAwaitingConfirmation(this.ticket.estado); },
    stateLabel() { return ticketStateLabel(this.ticket); },
    priorityLabel() { return PRIORITY_LABELS[this.ticket.priority] ? `Prioridad ${PRIORITY_LABELS[this.ticket.priority].toLowerCase()}` : ''; },
    badgeClass() {
      if (this.isAwaiting) return 'tli-badge--waiting';
      return this.isFinished ? 'tli-badge--done' : 'tli-badge--active';
    },
  },
  methods: {
    formatDay(day) {
      return new Date(`${day}T12:00:00`).toLocaleDateString('es-PE', { dateStyle: 'long' });
    },
    formatDate(iso) {
      if (!iso) return '';
      return new Date(iso).toLocaleString('es-PE', { dateStyle: 'medium', timeStyle: 'short' });
    },
  },
};
</script>

<style scoped>
.tli {
  border: 1px solid #eef1ef;
  border-radius: 12px;
  padding: 12px 14px;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.tli:hover { border-color: #d3ecde; background: #fafbfa; }
.tli-row { display: flex; justify-content: space-between; align-items: center; gap: 10px; }
.tli-main { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.tli-id { font-size: 12px; font-weight: 700; color: #01662E; letter-spacing: 0.3px; }
.tli-subject {
  font-size: 13.5px;
  color: #1f2937;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tli-sub { margin-top: 4px; font-size: 12px; color: #6b7280; }
.tli-badge {
  font-size: 11px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 12px;
  white-space: nowrap;
  flex-shrink: 0;
}
.tli-badge--active { background: #fff7e6; color: #b45309; }
.tli-badge--waiting { background: #fde8cf; color: #9a3412; }
.tli-badge--done { background: #e6f4ec; color: #01662E; }
.tli-detail {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #eef1ef;
  font-size: 12.5px;
  color: #374151;
  line-height: 1.6;
}
.tli-detail p { margin: 0 0 4px; }
.tli-detail a { color: #01662E; font-weight: 600; }
</style>
